import React, { Component } from 'react';

// 组件
import {
  DataTable,
  Icon,
  Checkbox,
  FormLayout,
  TextField,
  Pagination,
  Button,
  Spinner,
  Link,
  Tooltip,
  BlockStack,
  Modal,

} from '@shopify/polaris';
import AddKeywordsModal from "../../../../components/AddKeywordsModal"
import ImportKeywordsModal from "../../../../components/ImportKeywordsModal"
import DeleteModal from "../../../../components/DeleteModal"
import FooterPageSelect from '../../../../components/FooterPageSelect';
import EmptyTableTip from "../../../../components/EmptyTableTip";
// 样式+图标
import {
  SearchMinor,
  PlusMinor,
  CaretUpMinor,
  CaretDownMinor,
  SendMajor
} from "@shopify/polaris-icons";
import KeywordsResearchAdded from '../../../../assets/KeywordsResearchAdded'
import '../index.css';

// 接口
import {
  reqQueryCompetitorKeywordsDetail, reqAddKeywordsLibrary, reqAddKeywords,
} from '../../../../api';
import ApplyKeywordList from "../../../../components/ApplyKeywordList";
//翻译包
import Language from '../../../../i18n/Language';
import { cloneDeep, debounce } from 'lodash';
import AddToSegments from '../../../../components/AddToSegments';
const t = Language

class OrganicKeywords extends Component {

  state = {
    myKeywordsRow: [],
    myKeywordsListLength: 0,

    loading: true,

    checkStatus: [],

    // 排序
    orderBy: '',
    sortIndex: 1,
    orderBydirection: 'descending', //当前排序值
    headingIndex: 3, //默认排序选项

    // 搜索停顿
    delay: 0,
    // 搜索内容
    searchValue: '',

    // 分页
    page: 1,
    total: 0,
    hasPrevious: false,
    hasNext: true,
    size: 50,

    // 是否显示空页面
    isEmpty: false,
    // 所选择的ID
    tableInputID: [],
    tableCheckChecked: [],

    ScoreStautsArr: [],

    table: [],
    //全选
    checked: false,

    //添加关键词弹窗开关
    openAddKeywordsStatus: false,
    //导入关键词弹窗开关
    openImportKeywordsStatus: false,
    //删除弹窗开关
    openDeleteStatus: false,

    //多选添加按钮加载状态
    addLoadingStatus: false,

    relationId: 0,
    loadingArr: [],
    filterIDArr: [],
    current_PageSize: 50,
    userServices: this.props.userServices,

    applyModalState: false,
    applyKeywordVal: '', // 申请的关键词
    applyData: {}, // 选中数据
    applyLists: {},
    homeKey: '',
    isShowKeywordExit: false, // 关键词存在提示
    exitNums: 0, // 存在数量
    applyLoading: false,

    level: this.props.level,
    openState: false,
    keywordsSelData: {},
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps.userServices !== this.props.userServices) {
      this.setState({
        userServices: nextProps.userServices
      })
    }
    if (nextProps.level !== this.props.level) {
      this.setState({
        level: nextProps.level
      })
    }
    return true;
  }


  changeCheckbox = (index, value) => {

    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show(2);
      return;
    }

    var tableCheckArray = this.state.tableCheckChecked;
    tableCheckArray[index] = !tableCheckArray[index];

    //判断选中的数量
    var SelectedQuantity = 0;
    for (var i = 0; i < tableCheckArray.length; i++) {
      if (tableCheckArray[i] === true) {
        SelectedQuantity += 1;
      }
    }
    var checked = false;
    if (SelectedQuantity === 0) {
      checked = false;
    } else {
      checked = true;
    }
    this.setState({
      tableCheckChecked: tableCheckArray,
      myKeywordsListLength: SelectedQuantity,
      checked,
    }, () => {
      this.updateKeywordsList()
    })
  }

  handleChangeAllCheckbox = () => {

    //升级服务开关 
    if (this.props.userServices.CompetitorKeywords === false) {
      this.props.show(2);
      return;
    }

    var tableCheckArray = this.state.tableCheckChecked;
    var tableInputID = this.state.tableInputID;
    var filterIDArr = this.state.filterIDArr;

    if (!this.state.checked) {
      for (let i = 0; i < tableCheckArray.length; i++) {
        if (filterIDArr.indexOf(tableInputID[i]) !== -1) {
          tableCheckArray[i] = true
        }
        this.setState({
          myKeywordsListLength: filterIDArr.length,
          tableCheckChecked: tableCheckArray,
          checked: true
        }, () => {
          this.updateKeywordsList()
        })
      }
    } else {
      for (let i = 0; i < tableCheckArray.length; i++) {
        tableCheckArray[i] = false
        this.setState({
          tableCheckChecked: tableCheckArray,
          checked: false
        }, () => {
          this.updateKeywordsList()
        })
      }
    }
  }

  // 搜索事件
  handleSearchChange = (val) => {
    this.setState({
      searchValue: val,
    }, () => {
      this.queryGetKeywordsLibrary();
    })
  }

  handleSort = async (headingIndex, direction) => {
    var order = '';
    if (direction === 'descending') {
      order = 'DESC';
    } else if (direction === 'ascending') {
      order = 'ASC';
    }
    let index = headingIndex - 1;
    this.setState({
      headingIndex: headingIndex,
      orderBydirection: direction,
      orderBy: order,
      sortIndex: index,
      loading: true,
    }, () => {
      this.getKeywordsLibrary('sort')
    })
  }

  //批量添加
  BatchAddKeywords = async (checkArr, IDArr) => {
    //升级服务开关 
    let { level, table } = this.state;
    if (level !== 3) {
      this.props.show(2);
    } else {
      let idArr = [], keywordsSelData = [];
      for (let i = 0; i < checkArr.length; i++) {
        if (checkArr[i] === true) {
          idArr.push(IDArr[i])
        }
      }
      table.forEach(item => {
        if (idArr.includes(item.id)) {
          let { keyword, volume, cpc, kd, traffic } = item;
          keywordsSelData.push({
            keyword,
            volume,
            cpc,
            kd,
            traffic,
          })
        }
      })
      this.setState({
        openState: true,
        keywordsSelData,
      })
    }


    // this.setState({
    //   addLoadingStatus: true,
    // }, () => {
    //   this.updateKeywordsList()
    // })

    // const params = {
    //   type: 1,
    //   keywordsIdArr: idArr,
    //   relation_id: this.state.relationId,
    // }
    // const res = await reqAddKeywordsLibrary(params)
    // if (res.code === "200") {
    //   let clearArr = this.state.tableCheckChecked;
    //   let table = this.state.table
    //   for (let i = 0; i < clearArr.length; i++) {
    //     if (clearArr[i] === true) {
    //       table[i].is_add = true
    //     }
    //     clearArr[i] = false
    //   }
    //   this.setState({
    //     addLoadingStatus: false,
    //     checked: false,
    //     tableCheckChecked: clearArr,
    //     table
    //   }, () => {
    //     this.updateKeywordsList()
    //     this.props.toggleToast(res.msg, false)
    //   })
    // } else {
    //   this.setState({
    //     addLoadingStatus: false
    //   }, () => {
    //     this.props.toggleToast(res.msg, true)
    //   })
    // }
  }

  AddToLibrary = async (data) => {
    //升级服务开关 
    let { level } = this.state;
    if (level !== 3) {
      this.props.show(2);
    } else {
      let { keyword, volume, cpc, kd, traffic } = data;
      let keywordsSelData = [
        {
          keyword,
          volume,
          cpc,
          kd,
          traffic,
        }
      ];
      this.setState({
        openState: true,
        keywordsSelData,
      })
    }

    // let loadingArr = this.state.loadingArr;
    // loadingArr[index] = true;
    // let filterIDArr = this.state.filterIDArr;
    // filterIDArr.splice(filterIDArr.indexOf(this.state.tableInputID[index]), 1)
    // this.setState({
    //   loadingArr,
    //   filterIDArr
    // }, () => {
    //   this.updateKeywordsList()
    // })
    // const params = {
    //   type: 1,
    //   keywordsIdArr: id,
    //   relation_id: this.state.relationId,
    // }
    // const res = await reqAddKeywordsLibrary(params)
    // if (res.code === "200") {
    //   let table = this.state.table
    //   table[index].is_add = true
    //   this.setState({
    //     table,
    //   }, () => {
    //     this.updateKeywordsList()
    //     this.props.toggleToast(res.msg, false)
    //   })
    // } else {
    //   this.props.toggleToast(res.msg, true)
    // }
  }

  // 点击打开添加关键词弹窗
  openAddKeywordsModal = () => {
    this.setState({
      openAddKeywordsStatus: true
    })
  }

  // 添加关键词弹窗组件关闭 子组件传值到父组件
  AddKeywordsChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openAddKeywordsStatus: val
    })
  }

  // 点击打开导入关键词弹窗
  openImportKeywordsModal = () => {
    this.setState({
      openImportKeywordsStatus: true
    })
  }

  // 导入关键词弹窗组件关闭 子组件传值到父组件
  ImportKeywordsChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openImportKeywordsStatus: val
    })
  }

  // 点击打开删除弹窗
  openDeleteModal = () => {
    this.setState({
      openDeleteStatus: true
    })
  }

  // 删除弹窗组件关闭 子组件传值到父组件
  DeleteChildrenChange = (val) => {//这个val就是子组件传来的
    this.setState({
      openDeleteStatus: val
    })
  }

  updateKeywordsList = () => {
    let myKeywordsList = this.state.table.map((item, index) => {
      let checkbox_content = <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          disabled={Boolean(item?.is_add)}
          checked={this.state.tableCheckChecked[index]}
          onChange={this.changeCheckbox.bind(this, index)}
        />
      </div>;
      let keyword = <div style={{ width: '15rem', gap: '.5rem' }} title={item.keyword}>
        <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '14px' }}>{item.keyword}</div>
      </div>;
      let volume = item.volume;
      let kdColor = item.kd <= 40 ? 'ScoreItemGreen' : item.kd <= 70 ? 'ScoreItemOrange' : 'ScoreItemRed'
      let kd = <div className='ScoreItem'>
        <span className={kdColor}>{item.kd}</span>
      </div>;
      let cpc = item.cpc;
      let tp = item.traffic;
      let position = <div className='PositionItem'>
        {item.position_history < item.position ?
          <span className='PositionItemRed'><Icon source={CaretDownMinor} /><span>{item.position - item.position_history}</span></span> :
          <span className='PositionItemGreen'><Icon source={CaretUpMinor} /><span>{item.position_history - item.position}</span></span>
        }
        <span>{item.position}</span>
      </div>;
      let url = <div className='' style={{ width: '15rem' }} title={item.url}>
        <div style={{ width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', fontSize: '12px' }}><Link external url={item.url} removeUnderline>{item.url}</Link></div>
      </div>;
      let updated_at = item.last_updated_at;
      let isAdd = Boolean(item?.is_add) ?
        <span className='IsAddItemAdded'><Icon source={KeywordsResearchAdded} /></span> :
        <Button icon={PlusMinor} loading={Boolean(this.state.loadingArr[index])} onClick={() => this.AddToLibrary(item)}></Button>;
      let applyBtn = <Button icon={SendMajor} onClick={() => this.ApplyKeywords(item)}></Button>
      return ([
        checkbox_content,
        keyword,
        volume,
        kd,
        cpc,
        tp,
        position,
        url,
        updated_at,
        isAdd,
        applyBtn
      ]);
    });
    // 空页面判断
    if (myKeywordsList.length > 0) {
      this.setState({
        myKeywordsRow: myKeywordsList,
        isEmpty: false
      })
    } else {
      this.setState({
        myKeywordsRow: myKeywordsList,
        isEmpty: true
      })
    }
  }

  // 打开申请弹窗
  ApplyKeywords = (data) => {
    this.setState({
      applyModalState: true,
      applyKeywordVal: data.keyword,
    })
  }

  //获取关键词库列表
  getKeywordsLibrary = async (sort = '') => {
    if (sort === 'sort') {

    } else {
      this.setState({
        loading: true,
      });
    }
    const params = {
      id: this.props.id,
      type: 1,
      page: this.state.page,
      size: this.state.size,
      sortType: this.state.orderBy,
      sortIndex: this.state.orderBy !== '' ? this.state.sortIndex : '',
      q: this.state.searchValue ? this.state.searchValue : '',
    };
    const res = await reqQueryCompetitorKeywordsDetail(params);
    if (res.code === "200") {
      var tableInputCheckedArr = [];
      let ScoreStautsArr = [];
      var loadingArr = [];
      var filterIDArr = [];
      // console.log(res.data);

      //表格ID
      var tableInputIDArr = [];
      for (let i = 0; i < res.data.length; i++) {
        tableInputCheckedArr.push(false)
        ScoreStautsArr.push(res.data[i].status);
        tableInputIDArr.push(res.data[i].id);
        loadingArr.push(false)
        if (!(res.data[i] && res.data[i]?.is_add)) {
          filterIDArr.push(res.data[i].id)
        }
      }

      // 更新分页数据
      const maxPage = Math.ceil(res.count / this.state.size);

      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      this.setState({
        table: res.data,
        loading: false,
        checkStatus: tableInputCheckedArr, //选中的个数数组 默认是全false
        total: res.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        tableCheckChecked: tableInputCheckedArr,
        tableInputID: tableInputIDArr,
        relationId: res.count > 0 ? res.data[0].relation_id : null,
        loadingArr,
        filterIDArr,
      }, () => {
        this.updateKeywordsList()
      })
    } else {
      this.props.toggleToast(res.msg, true)
    }
  }

  //查询关键词
  queryGetKeywordsLibrary = debounce(async (sort = '') => {
    if (sort === 'sort') {

    } else {
      this.setState({
        loading: true,
        page: 1
      });
    }
    const params = {
      id: this.props.id,
      type: 1,
      page: this.state.page,
      size: this.state.size,
      q: this.state.searchValue ? this.state.searchValue : '',
    };
    const res = await reqQueryCompetitorKeywordsDetail(params);

    if (res.code === "200") {
      // 更新分页数据
      const maxPage = Math.ceil(res.count / this.state.size);

      var hasPrevious = ""
      var hasNext = ""
      //如果当前页面大于1 且 小于 总分页   上下都为开启
      if (this.state.page > 1 && this.state.page < maxPage) {
        hasPrevious = true;
        hasNext = true;
        //如果当前页面小于等于1 且 小于总分页 下关闭 上开启
      } else if (this.state.page <= 1 && this.state.page < maxPage) {
        hasPrevious = false;
        hasNext = true;
        //如果当前页面大于1 且 大于等于 总分页   下开启 上关闭
      } else if (this.state.page > 1 && this.state.page >= maxPage) {
        hasPrevious = true;
        hasNext = false;
        // 否则都关闭
      } else if (this.state.page <= 1 && this.state.page >= maxPage) {
        hasPrevious = false;
        hasNext = false;
      }

      this.setState({
        table: res.data,
        loading: false,
        total: res.count, //总关键词条数
        hasPrevious: hasPrevious,
        hasNext: hasNext
      }, () => {
        this.updateKeywordsList()
      })
    } else {
      this.props.toggleToast(res.msg, true)
    }
  }, 500)

  handleClearButtonClick = () => {
    this.setState({
      searchValue: ""
    }, () => {
      this.getKeywordsLibrary()
    })
  }

  // 确认申请
  handleApplyChange = (confirm = -1) => {
    let { applyKeywordVal, applyData, applyLists, homeKey } = this.state;
    let listPar = {};
    let typeAll = {
      "Products": "product",
      "Collections": "collection",
      "Blogs": "blog",
      "Other Pages": "page",
    }
    let operaList = [];
    Object.keys(applyData).forEach(item => {
      if (applyData[item].length > 0) {
        operaList.push({
          tag: item,
          list: applyData[item]
        });
        if (item === "Homepage") {
          listPar.home = applyData[item];
        } else {
          listPar[typeAll[item]] = applyData[item];
        }
      }
    })
    let isExitState = false, exitNums = 0;
    operaList.forEach(item => {
      if (item.tag === "Homepage") {
        if (homeKey !== '') {
          isExitState = true;
          exitNums += 1;
        }
      } else {
        applyLists[item.tag].list.forEach(obj => {
          if (item.list.includes(obj.id) && obj.primary_keywords) {
            isExitState = true;
            exitNums += 1;
          }
        })
      }
    })
    if (isExitState && confirm === -1) {
      // 提示关键词存在
      let nodeDom = document.querySelector('.apply_keyword_list');
      if (nodeDom && nodeDom.parentNode.parentNode) {
        nodeDom.parentNode.parentNode.style.display = 'none';
      }
      this.setState({
        isShowKeywordExit: true,
        exitNums,
      })
    } else {
      this.setState({
        applyLoading: true,
      }, async () => {
        let params = {
          keyword: applyKeywordVal,
          list: listPar
        }
        const res = await reqAddKeywords(params);
        if (res.ack === 1) {
          // this.props.toggleToast(res.msg);
          this.props.toggleToast(t("Sucessfully"));
          this.setState({
            applyModalState: false,
            isShowKeywordExit: false,
            exitNums: 0,
          })
        } else {
          this.setState({
            applyModalState: false,
            isShowKeywordExit: false,
            exitNums: 0,
          })
          this.props.toggleToast(t("Try again later"), true);
        }

        if (res) {
          this.setState({
            applyLoading: false,
          })
        }
      })
    }
  }

  // 关闭申请弹窗
  handleApplyCancel = () => {
    this.setState({
      applyModalState: false,
    })
  }

  // 选中数据
  changeSelectApply = (data, lists, homeKey) => {
    this.setState({
      applyData: data,
      applyLists: lists,
      homeKey,
    })
  }

  // 关闭
  handleExitClose = () => {
    let nodeDom = document.querySelector('.apply_keyword_list');
    if (nodeDom && nodeDom.parentNode.parentNode) {
      nodeDom.parentNode.parentNode.style.display = 'flex';
    }
    this.setState({
      isShowKeywordExit: false,
    })
  }

  // 确认覆盖关键词
  handleExitConfirm = () => {
    let nodeDom = document.querySelector('.apply_keyword_list');
    if (nodeDom && nodeDom.parentNode.parentNode) {
      nodeDom.parentNode.parentNode.style.display = 'flex';
    }
    this.setState({
      isShowKeywordExit: false,
    }, () => {
      this.handleApplyChange(1)
    })
  }

  // 选择表格条数
  changePageSize = (e) => {
    this.setState({
      page: 1,
      size: Number(e),
      current_PageSize: Number(e)
    }, () => {
      this.getKeywordsLibrary()
    })
  }

  // 关闭弹窗
  handleCloseCreateModal = () => {
    this.setState({
      openState: false,
    })
  }

  // 更新状态
  handleUpdCollect = () => {
    let { keywordsSelData, filterIDArr, tableCheckChecked } = this.state;
    let tableNew = cloneDeep(this.state.table);
    let newFilterIdArr = cloneDeep(filterIDArr);
    tableNew.forEach((t, i) => {
      if (tableCheckChecked[i]) {
        tableCheckChecked[i] = false;
      }
      if (t.keyword === keywordsSelData[0].keyword) {
        t.is_add = true;
        if (newFilterIdArr.indexOf(t.id) > -1) {
          newFilterIdArr.splice(newFilterIdArr.indexOf(t.id), 1);
        }
      }
    })
    this.setState({
      table: tableNew,
      filterIDArr: newFilterIdArr,
      myKeywordsListLength: 0,
      checked: false,
    }, () => {
      this.updateKeywordsList()
    })
  }

  componentDidMount() {
    this.getKeywordsLibrary();
  }

  componentWillUnmount() {
    this.setState = () => false;
  }

  render() {
    const {
      state: {
        checked,
        myKeywordsRow,
        myKeywordsListLength,
        loading,
        orderBydirection,
        headingIndex,
        searchValue,
        isEmpty,
        page,
        total,
        size,
        hasPrevious,
        hasNext,
        tableCheckChecked,
        tableInputID,
        openAddKeywordsStatus,
        openImportKeywordsStatus,
        openDeleteStatus,
        addLoadingStatus,
        current_PageSize,
        applyModalState,
        applyKeywordVal,
        applyData,
        isShowKeywordExit,
        exitNums,
        applyLoading,
        level,
        openState,
        keywordsSelData,

      },
      getKeywordsLibrary,
      handleChangeAllCheckbox,
      handleSort,
      handleSearchChange,
      BatchAddKeywords,
      AddKeywordsChildrenChange,
      ImportKeywordsChildrenChange,
      DeleteChildrenChange,
      changePageSize
    } = this;

    // 应用关键词弹窗
    const ApplyKeywordModal = <Modal
      title={t("Apply this keyword to")}
      open={applyModalState}
      onClose={this.handleApplyCancel}
      primaryAction={{
        content: t("Apply"),
        onAction: () => this.handleApplyChange(-1),
        loading: applyLoading,
        disabled: !Boolean(Object.keys(applyData).length > 0 && Object.keys(applyData).filter(item => applyData[item].length > 0).length > 0)
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          disabled: applyLoading,
          onAction: this.handleApplyCancel,
        },
      ]}
    >
      <ApplyKeywordList
        mode="multiple"
        applyKeywordVal={applyKeywordVal}
        changeSelectApply={this.changeSelectApply}
      />
    </Modal>

    // 关键词存在提示弹窗
    const KeywordExitModal = <Modal
      title={t("Apply this keyword to this product")}
      open={isShowKeywordExit}
      primaryAction={{
        content: t("Yes"),
        onAction: this.handleExitConfirm,
      }}
      secondaryActions={[
        {
          content: t("Cancel"),
          onAction: this.handleExitClose,
        },
      ]}
      onClose={this.handleExitClose}
    >
      <p style={{ padding: '1rem' }}>
        {t("{{v1}} of the pages you selected contains keywords. Do you want to replace it with new keyword?", exitNums)}
      </p>
    </Modal>

    var showEmpty = "";
    if (total === 0) {
      showEmpty = <EmptyTableTip content={t("Nothing fits into the category")} overview={t("Please check elsewhere.")} mixheight={"400"} />
    }

    let headings = [
      isEmpty ? <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          label=""
          disabled
          checked={checked}
          onChange={handleChangeAllCheckbox}
        />
      </div> : <div style={{ paddingLeft: "8px" }}>
        <Checkbox
          label=""
          checked={checked}
          onChange={handleChangeAllCheckbox}
        />
      </div>,
      t("Keyword"),
      <Tooltip content={t("An estimation of the number of searches for a keyword over the latest month.")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("Volume")}</span>
      </Tooltip>,
      <Tooltip content={t("Keyword Difficulty gives an estimation of how hard it is to rank in the top 10 organic search results for a keyword on a 100-point scale.")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("KD")}</span>
      </Tooltip>,
      <Tooltip content={t("Cost Per Click shows the average price that advertisers pay for each ad click in paid search results for a keyword.")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("CPC")}</span>
      </Tooltip>,
      <Tooltip content={t("An estimation of the number of monthly visitors that your target gets from organic search for a keyword. We base this on the number of searches for that keyword over the latest month.")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("Traffic")}</span>
      </Tooltip>,
      <Tooltip content={t("The top position your target ranks for in the organic search results for a keyword. Positions might be shown as \"lost\" in cases where your target stops ranking for this keyword, or if its keyword volume is so low that we stopped updating it.")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("Position")}</span>
      </Tooltip>,
      <Tooltip content={t("The URL that is ranking in organic search results. If there are multiple URLs ranking for a single keyword, we show the top URL.")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("URL")}</span>
      </Tooltip>,
      t("Updated"),
      <Tooltip content={t("Add this keyword to Categories")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("Collect")}</span>
      </Tooltip>,
      <Tooltip content={t("Apply this keyword to your store page")}>
        <span className="TitleHover" style={{ cursor: 'default' }}>{t("Apply")}</span>
      </Tooltip>,

    ]

    var addButton = "";
    var SelectedQuantityText = "";

    addButton = <Button loading={addLoadingStatus} onClick={() => { BatchAddKeywords(tableCheckChecked, tableInputID) }}><span style={{ whiteSpace: 'nowrap' }}>{t("Add to categories")}</span></Button>;
    SelectedQuantityText = myKeywordsListLength + " " + t("selected");

    var sortableData = [false, false, true, true, true, true, true, false, false, false]

    if (checked) {
      sortableData = [false, false, false, false, false, false, false, false, false, false]
      headings = [
        <div className="headings_div1">
          <div className="headings_div2">
            <div className="Polaris-ResourceList-BulkActions__ButtonGroup">
              <div className="Polaris-ResourceList-CheckableButton Polaris-ResourceList-CheckableButton__CheckableButton--selectMode Polaris-ResourceList-CheckableButton__CheckableButton--selected">
                <div className="headings_div3">
                  <Checkbox
                    checked={checked}
                    onChange={handleChangeAllCheckbox}
                  />
                </div>
                <span className="Polaris-ResourceList-CheckableButton__Label">
                  {SelectedQuantityText}
                </span>
              </div>
              {addButton}
            </div>
          </div>
        </div>,
        <span className='none_text'>{t("Keyword")}</span>,
        <span className='none_text'>{t("Volume")}</span>,
        <span className='none_text'>{t("KD")}</span>,
        <span className='none_text'>{t("CPC")}</span>,
        <span className='none_text'>{t("Traffic")}</span>,
        <span className='none_text'>{t("Position")}</span>,
        <span className='none_text'>{t("URL")}</span>,
        <span className='none_text'>{t("Updated")}</span>,
        <span className='none_text'>{t("Collect")}</span>,
        <span className='none_text'>{t("Apply")}</span>,
      ];
    }

    var footerContentMsg = "";
    if (total > 0) {
      const startNum = (page - 1) * size + 1;
      const endNum = page * size > total ? total : page * size;
      // footerContentMsg = t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);
      footerContentMsg = window.innerWidth >= 550 ? <FooterPageSelect changePageSize={changePageSize} startNum={startNum} endNum={endNum} total={total} current_PageSize={current_PageSize} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);

    }
    const tableLoading = loading ? (
      <div style={{ padding: '30rem 0', textAlign: 'center' }}>
        <Spinner size="large" color="teal" />
      </div>
    ) : (
      isEmpty ? <>
        <DataTable
          columnContentTypes={[
            "text",
            "text",
            "text",
            "numeric",
            "numeric",
            "numeric",
            "numeric",
            "text",
            "text",
            "text",
          ]}
          headings={headings}
          rows={myKeywordsRow}
          sortable={[false, false, false, false, false, false, false, false, false, false]} // 需要排序把false 改成true [false, false, true, true, false, false]
          defaultSortDirection={orderBydirection} //ascending descending none
          initialSortColumnIndex={headingIndex}
          onSort={handleSort}
          verticalAlign="middle"
        />
        {showEmpty}
      </> : <>
        <DataTable
          columnContentTypes={[
            "text",
            "text",
            "text",
            "numeric",
            "numeric",
            "numeric",
            "numeric",
            "text",
            "text",
            "text",
          ]}
          headings={headings}
          rows={myKeywordsRow}
          sortable={sortableData} // 需要排序把false 改成true [false, false, true, true, false, false]
          defaultSortDirection={orderBydirection} //ascending descending none
          initialSortColumnIndex={headingIndex}
          onSort={handleSort}
          verticalAlign="middle"
        />
        {/* <div className="Polaris-DataTable__Footer">
          {footerContentMsg}
        </div> */}
        <div className={`justify_center ${current_PageSize > 5 && myKeywordsRow.length > 7 ? 'sticky_footer' : ''}`}>
          {/* <div className="Polaris-DataTable__Footer_right_button">
          </div> */}
          <Pagination
            label={footerContentMsg}
            hasPrevious={hasPrevious}
            onPrevious={() => {
              this.setState(({
                page: page - 1,
                checked: false,
                tableCheckChecked: [],
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
            hasNext={hasNext}
            onNext={() => {
              this.setState(({
                page: page + 1,
                checked: false,
                tableCheckChecked: [],
              }), () => {
                //重新请求列表
                getKeywordsLibrary();
              });
            }}
          />
        </div>
      </>
    );

    const pageContent = <div className='DataTable'>
      {ApplyKeywordModal}
      {KeywordExitModal}
      <div style={{ padding: '0.5rem 1rem 0' }}>
        <TextField
          value={searchValue}
          onChange={handleSearchChange}
          placeholder={t("search keyword")}
          prefix={<Icon source={SearchMinor} />}
          clearButton
          onClearButtonClick={this.handleClearButtonClick}
        />
      </div>
      {tableLoading}
      <AddKeywordsModal
        open={openAddKeywordsStatus}
        changeData={AddKeywordsChildrenChange}
      />
      <ImportKeywordsModal
        open={openImportKeywordsStatus}
        changeData={ImportKeywordsChildrenChange}
      />
      <DeleteModal
        open={openDeleteStatus}
        changeData={DeleteChildrenChange}
      />
      <AddToSegments
        type={"Keywords-organic"}
        level={level}
        openState={openState}
        keywordsSelData={keywordsSelData}
        toggleToast={this.props.toggleToast}
        show={this.props.show}
        handleCloseModal={this.handleCloseCreateModal}
        handleUpdCollect={this.handleUpdCollect}
      />
    </div>

    return (
      pageContent
    );
  }
}

export default OrganicKeywords;